import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import pic1 from '../images/team/pic1.jpg';
import { useAuthStore, useProfileStore } from '../store';
import { updateProfilePicture } from '../services/ProfileService';
import swal from 'sweetalert';
import { resolveProfilePhotoUrl } from '../helpers/profilePhoto';

export function UserSidebar() {
    const { auth, logout } = useAuthStore();
    const { profile, fetchProfile } = useProfileStore();
    const location = useLocation();
    const [isUploading, setIsUploading] = useState(false);

    // Si hay usuario autenticado y no hay perfil cargado, obtenerlo del backend
    useEffect(() => {
        if (auth.user && !profile) {
            fetchProfile();
        }
    }, [auth.user, profile, fetchProfile]);

    const isActive = (path) => {
        return location.pathname === path ? 'active' : '';
    };

    const profilePhotoUrl = resolveProfilePhotoUrl(profile, auth.user);

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        const inputElement = e.target;

        if (!file) return;

        // Validar tipo de archivo
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
        if (!validTypes.includes(file.type)) {
            swal('Error', 'Por favor selecciona una imagen válida (JPG, PNG, GIF)', 'error');
            inputElement.value = '';
            return;
        }

        // Validar tamaño (máx 5MB)
        if (file.size > 5 * 1024 * 1024) {
            swal('Error', 'La imagen no debe superar los 5MB', 'error');
            inputElement.value = '';
            return;
        }

        setIsUploading(true);
        try {
            const response = await updateProfilePicture(file);

            // Actualizar el perfil completo del backend primero
            await fetchProfile();

            swal('¡Éxito!', response.data.message || 'Foto de perfil actualizada correctamente', 'success');
        } catch (error) {
            console.error('Error al subir la foto:', error);
            swal('Error', error.response?.data?.message || 'Error al actualizar la foto de perfil', 'error');
        } finally {
            setIsUploading(false);
            inputElement.value = '';
        }
    };

    return (
        <div className="col-xl-3 col-lg-4 m-b30" style={{ backgroundColor: '#f8fafd' }}>
            <div className="sticky-top">
                <div className="candidate-info">
                    <div className="candidate-detail text-center">
                        <div className="canditate-des">
                            <img
                                alt="Foto de perfil"
                                src={profilePhotoUrl}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    objectPosition: 'center'
                                }}
                            />
                            <div
                                className="upload-link"
                                title={isUploading ? 'Subiendo...' : 'Actualizar foto'}
                                data-toggle="tooltip"
                                data-placement="right"
                                style={{ opacity: isUploading ? 0.5 : 1, cursor: isUploading ? 'wait' : 'pointer' }}
                            >
                                <input
                                    type="file"
                                    className="update-flie"
                                    onChange={handleFileChange}
                                    accept="image/jpeg,image/jpg,image/png,image/gif"
                                    disabled={isUploading}
                                />
                                <i className={isUploading ? 'fa fa-spinner fa-spin' : 'fa fa-camera'}></i>
                            </div>
                        </div>
                        <div className="candidate-title">
                            <div className="">
                                <h4 className="m-b5">{auth.user?.nombre + ' ' + auth.user?.apellido}</h4>
                                {/* <p className="m-b0">Desarrollador Web</p> */}
                            </div>
                        </div>
                    </div>
                    <ul>
                        <li>
                            <Link to={"/profile"} className={isActive('/profile')}>
                                <i className="fa fa-user-o" aria-hidden="true"></i>
                                <span>Perfil</span>
                            </Link>
                        </li>
                        <li>
                            <Link to={"/my-resume"} className={isActive('/my-resume')}>
                                <i className="fa fa-file-text-o" aria-hidden="true"></i>
                                <span>Mi Currículum</span>
                            </Link>
                        </li>
                        <li>
                            <Link to={"/applied-jobs"} className={isActive('/applied-jobs')}>
                                <i className="fa fa-briefcase" aria-hidden="true"></i>
                                <span>Ofertas aplicadas</span>
                            </Link>
                        </li>
                        <li>
                            <Link to={"/saved-jobs"} className={isActive('/saved-jobs')}>
                                <i className="fa fa-heart-o" aria-hidden="true"></i>
                                <span>Ofertas guardadas</span>
                            </Link>
                        </li>
                        {/* <li>
                            <Link to={"/change-password"} className={isActive('/change-password')}>
                                <i className="fa fa-key" aria-hidden="true"></i>
                                <span>Cambiar contraseña</span>
                            </Link>
                        </li> */}
                        <li>
                            <Link to={"./"} onClick={logout}>
                                <i className="fa fa-sign-out" aria-hidden="true"></i>
                                <span>Cerrar sesión</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
